import { useQuery } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCartService } from 'services';

export const useBootstrapDsoCart = () => {
  return useQuery(
    ServerStateKeysEnum.dsoCart,
    () => {
      return dsoCartService.bootstrapUserAndCart();
    },
    {
      staleTime: Infinity,
      onSuccess: data => {
        console.log(data);
      },
      onError: error => {
        console.error(error);
      },
    }
  );
};
